<template>
  <section class="page-hero">
    <div class="page-hero__glow"></div>
    <div class="page-hero__grid"></div>
    <div class="ns-wrap">
      <p class="ns-eyebrow">{{ eyebrow }}</p>
      <h1>{{ title }}</h1>
      <p v-if="subtitle">{{ subtitle }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "PageHero",
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ""
    },
    eyebrow: {
      type: String,
      default: "NOUSI · AI TECHNOLOGY"
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PageHero.vue